class DonateModal{

	constructor($target) {
		
		//Private properties
        $target;
		let name = "HELLO";

        var donateButton = $target.find(".donate_button_click");
        var donateModal = $target.find(".donate_modal");
        var donateClose = $target.find("#donate_hamburger");
		
	
		function init(){
			addEventListeners(); 
		}

        function addEventListeners(){
			//click the menu
			$(donateButton).click(openDonate);
			$(donateClose).click(closeDonate);
			
				
		}

        function openDonate(event){
			event.stopPropagation();
			event.stopImmediatePropagation();
			$(donateModal).addClass('modal_open');

			if ((donateModal).hasClass("modal_open")) {
				$("body").css("overflow-y", "hidden");
			}
		}

        function closeDonate(){
			$(donateModal).removeClass('modal_open');
			if ((donateModal).hasClass("modal_open")) {
				$("body").css("overflow-y", "hidden");
			}
			else{
				$("body").css("overflow-y", "auto");
			}
		}
		

		init();
		return {

			//Public properties
			name:name,

			publicBlockHero:function(string){

				// $target.append("HELLO!"+string);
				// console.log(name)
				// console.log(string)
				// console.log($target)

			}

		}

	}

}

export default DonateModal;